import axios from "axios";
import { getApiBaseUrl } from "src/config/Endpoints";
import { getApiKey } from "src/utils/getters";

const API_BASE_URL = getApiBaseUrl();

export interface FeedbackSubmitResponse {
  status: string;
  message: string;
  feedback_id: number;
}

export interface FaqItem {
  faq_id: number;
  question: string;
  answer: string;
  category: string | null;
}

export interface FaqsResponse {
  status: string;
  faqs: FaqItem[];
}

export const submitBugReport = async (
  description: string,
  images: File[],
  page?: string,
  subpage?: string,
  url?: string
): Promise<FeedbackSubmitResponse> => {
  const apiKey = getApiKey();

  const formData = new FormData();
  formData.append("description", description);
  images.forEach(file => formData.append("images", file));
  if (page) {formData.append("page", page);}
  if (subpage) {formData.append("subpage", subpage);}
  if (url) {formData.append("url", url);}

  const response = await axios.post(
    `${API_BASE_URL}/feedback/bug-report`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${apiKey}`,
      },
    }
  );

  return response.data;
};

export const submitFeatureRequest = async (
  description: string,
  images: File[],
  page?: string,
  subpage?: string,
  url?: string
): Promise<FeedbackSubmitResponse> => {
  const apiKey = getApiKey();

  const formData = new FormData();
  formData.append("description", description);
  images.forEach(file => formData.append("images", file));
  if (page) {formData.append("page", page);}
  if (subpage) {formData.append("subpage", subpage);}
  if (url) {formData.append("url", url);}

  const response = await axios.post(
    `${API_BASE_URL}/feedback/feature-request`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${apiKey}`,
      },
    }
  );

  return response.data;
};

export const submitGeneralSupport = async (
  question: string
): Promise<FeedbackSubmitResponse> => {
  const apiKey = getApiKey();

  const response = await axios.post(
    `${API_BASE_URL}/feedback/general-support`,
    { question },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiKey}`,
      },
    }
  );

  return response.data;
};

export const fetchFaqs = async (category?: string): Promise<FaqsResponse> => {
  const apiKey = getApiKey();

  const params = category ? { category } : undefined;

  const response = await axios.get(`${API_BASE_URL}/feedback/faqs`, {
    headers: {
      Authorization: `Bearer ${apiKey}`,
    },
    params,
  });

  return response.data;
};
